/**
 * No Ajax Override
 * 
 * This script intercepts and blocks AJAX requests for variant selection.
 * It should be loaded before product-info.js and all other product-related scripts.
 */

(function() {
  // Flag to track if we've successfully patched things
  let patchStatus = {
    xhr: false,
    fetch: false,
    pubsub: false
  };

  // Block AJAX requests for variant changes
  const originalXHROpen = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
    // Check if this is a variant-related AJAX request
    if (url && typeof url === 'string' && url.includes('option_values=')) {
      console.log('BLOCKED XHR request for variant change:', url, 'Method:', method);
      
      // Override the send method to do nothing
      this.send = function() {
        console.log('BLOCKED XHR send() called');
      };
      
      // Add a fake readyState property that equals DONE (4)
      Object.defineProperty(this, 'readyState', { value: 4, writable: false });
      
      // Add a fake status property
      Object.defineProperty(this, 'status', { value: 200, writable: false });
      
      // Add empty response properties
      Object.defineProperty(this, 'responseText', { value: '', writable: false });
      Object.defineProperty(this, 'response', { value: '', writable: false });
      
      // Simulate the request being done
      setTimeout(() => {
        if (typeof this.onreadystatechange === 'function') {
          console.log('Calling fake XHR onreadystatechange');
          this.onreadystatechange();
        }
        if (typeof this.onload === 'function') {
          console.log('Calling fake XHR onload');
          this.onload();
        }
      }, 10);
      
      patchStatus.xhr = true;
      return;
    }
    
    // Otherwise, proceed with the original request
    return originalXHROpen.apply(this, arguments);
  };
  // Store the original fetch function
  const originalFetch = window.fetch;
  
  // Override the fetch function to also block variant-related requests
  window.fetch = function(resource, options) {
    // Convert to string if it's a Request object
    const url = typeof resource === 'string' ? resource : resource.url;
    
    // Check if this is a variant-related request
    if (url && url.includes('option_values=')) {
      console.log('BLOCKED fetch request for variant change:', url, 'Options:', options);
      
      // Return an empty resolved promise with a fake response
      patchStatus.fetch = true;
      return Promise.resolve({
        ok: true,
        status: 200,
        text: () => {
          console.log('Fetch text() called on blocked request');
          return Promise.resolve('');
        },
        json: () => {
          console.log('Fetch json() called on blocked request');
          return Promise.resolve({});
        },
      });
    }
    
    // Otherwise, proceed with the original fetch
    return originalFetch.apply(this, arguments);
  };

  // Also patch the PubSub system once it's available
  function patchPubSub() {
    if (typeof window.publish === 'function') {
      const originalPublish = window.publish;
      
      window.publish = function(eventName, payload) {
        
        // If it's a variant change event, we might want to intercept
        if (eventName === 'option-value-selection-change') {
          const productInfo = document.querySelector('product-info');
          
          if (productInfo && productInfo.getAttribute('data-update-url') === 'false') {
            
            // Find our no-ajax-variants component
            const noAjaxVariants = document.querySelector('no-ajax-variants');
            if (noAjaxVariants && typeof noAjaxVariants.handleVariantChange === 'function') {
              setTimeout(() => {
                try {
                  noAjaxVariants.handleVariantChange(payload);
                } catch (e) {
                  console.error('Error in no-ajax-variants.handleVariantChange:', e);
                }
              }, 0);
            }
            
            // Let events propagate to our no-ajax-variants component, but not to product-info.js
            setTimeout(() => {
              const event = new CustomEvent('variant:changed', {
                detail: { variant: null, isBlockedAjax: true }
              });
              document.dispatchEvent(event);
            }, 10);
            
            // Allow original publish to happen so other components receive the event
            patchStatus.pubsub = true;
            return originalPublish(eventName, payload);
          }
        }
        
        // For all other events, proceed normally
        return originalPublish(eventName, payload);
      };
      
    } else {
      // Try again after a delay
      setTimeout(patchPubSub, 50);
    }
  }
  
  // Start trying to patch the PubSub system
  patchPubSub();
  
})(); 